import { useCallback } from 'react';
import { DashboardService } from 'api/services/DashboardService';

const useGoogleCalendar = () => {
  const getCalendarEvents = useCallback(
    async (timeMin: string, timeMax: string, maxResults: number = 100) =>
      DashboardService.apiDashboardGoogleCalendarEventsList(timeMin, timeMax, maxResults),
    []
  );

  return { getCalendarEvents };
};

export default useGoogleCalendar;